import React from 'react';
var Switch = function (_a) {
    var onClick = _a.onClick, checkedIcon = _a.checkedIcon, uncheckedIcon = _a.uncheckedIcon, checked = _a.checked;
    return (React.createElement("label", { className: 'common-switch', htmlFor: 'common-switch__checkbox' },
        React.createElement("input", { type: 'checkbox', className: 'common-switch__checkbox', id: 'common-switch__checkbox', onClick: onClick, defaultChecked: checked }),
        React.createElement("span", { className: 'common-switch__slider' },
            checkedIcon && React.createElement("div", null, checkedIcon),
            uncheckedIcon && React.createElement("div", null, uncheckedIcon))));
};
export default Switch;
